import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function CommissionDomainesList() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [commission, setCommission] = useState(null);
    console.log('id',id)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/commission_coms/${id}`, { credentials: "include" })
            .then(r => r.json())
            .then(data => setCommission(data));
    }, [id]);
console.log('ssd',commission)
  // Sécurité au cas où l'utilisateur accède à l'URL directement sans passer par la liste
  if (!commission) {
    return (
        <div className="fr-container">
          <p>Aucune donnée disponible. Veuillez repasser par la liste.</p>
          <button onClick={() => navigate("/")}>Retour à l'accueil</button>
        </div>
    );
  }

  return (
      <div className="fr-container">
        <h2>Domaines de la commission : {commission.comLib}</h2>

        <table border="1" className="fr-table">
          <thead>
          <tr>
            <th>ID Domaine</th>
            <th>Code</th>
            <th>Libellé</th>
          </tr>
          </thead>
          <tbody>
          {commission.domaines && commission.domaines.length > 0 ? (
              commission.domaines.map((dom) => (
                  <tr key={dom.domId}>
                    <td>{dom.domId}</td>
                    <td>{dom.domCode || 'N/A'}</td>
                    <td>{dom.domLib}</td>
                  </tr>
              ))
          ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  <em>Aucun domaine associé</em>
                </td>
              </tr>
          )}
          </tbody>
        </table>

        <button
            className="fr-btn fr-btn--secondary fr-mt-2w"
            onClick={() => navigate(-1)}
        >
          Retour à la liste
        </button>
      </div>
  );
}